/* Site motion (approved 28 Oct 2026; docs/design.md, Motion). Styles in custom-site-standards.css.
 * - Rise-in: rows of cards and a few images fade up 12 px as they come on screen, 70 ms apart. A row reveals together,
 *   so cards still off to the side of a sideways row never wait for a swipe. Anything already on screen at load stays put.
 * - Press: buttons shrink to 98% while pressed (CSS); iPhone Safari needs a touch listener for :active to apply.
 * - Price fade: a purchase-panel price that changes fades back in, so the change registers.
 * Nothing runs under reduced motion or in the Theme Editor; without this script everything simply shows. */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('touchstart', () => {}, { passive: true });

  // [row, items in it]
  const GROUPS = [
    ['.presell-before-after__track', '.presell-before-after__card'],
    ['.grv-cards', '.grv-card'],
    ['.ingredient-cards__track', '.ingredient-cards__card'],
    ['.presell-daily-ritual__track', '.presell-daily-ritual__step'],
    ['.g-founder__inner', '.g-founder__image'],
    ['.g-guarantee__inner', '.g-guarantee__card'],
  ];
  const STAGGER_MAX = 3; // later cards in a row share the fourth card's delay

  // Measured after the page has loaded and the browser is idle, so the measuring doesn't hold up the first paint on phones (2 Nov 2026).
  const setUpRise = () => {
    if ('IntersectionObserver' in window) {
      const rows = [];
      for (const [rowSelector, itemSelector] of GROUPS) {
        for (const row of document.querySelectorAll(`#root ${rowSelector}`)) {
          if (row.getBoundingClientRect().top < window.innerHeight) continue; // on screen at load: leave as is
          const items = row.querySelectorAll(itemSelector);
          if (!items.length) continue;
          items.forEach((item, i) => {
            item.classList.add('g-reveal');
            item.style.setProperty('--g-reveal-index', Math.min(i, STAGGER_MAX));
          });
          rows.push(row);
        }
      }
      if (rows.length) {
        document.documentElement.classList.add('g-motion');
        const observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.querySelectorAll('.g-reveal').forEach((item) => item.classList.add('is-revealed'));
            observer.unobserve(entry.target);
          }
        }, { rootMargin: '0px 0px -10% 0px' });
        rows.forEach((row) => observer.observe(row));
      }
    }
  };
  const whenIdle = () => (window.requestIdleCallback ? requestIdleCallback(setUpRise, { timeout: 2000 }) : setTimeout(setUpRise, 200));
  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle, { once: true });

  const PRICES = '.gs__price-row, .gs__daily-line, .supply-choice-price, [data-sticky-price]';
  const fade = (element) => {
    element.classList.remove('g-price-fade');
    void element.offsetWidth; // restart the animation
    element.classList.add('g-price-fade');
  };
  const watchPrices = (root) => {
    new MutationObserver((mutations) => {
      const changed = new Set();
      for (const mutation of mutations) {
        const node = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        const price = node && node.closest(PRICES);
        if (price) changed.add(price);
        for (const added of mutation.addedNodes) {
          if (added.nodeType !== 1) continue;
          if (added.matches(PRICES)) changed.add(added);
          added.querySelectorAll(PRICES).forEach((inner) => changed.add(inner));
        }
      }
      changed.forEach(fade);
    }).observe(root, { subtree: true, childList: true, characterData: true });
  };
  document.querySelectorAll('.gs, .gss').forEach(watchPrices);
})();
